/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Digitell_Ja10Inputs */

const en__field_enum_digitell_ja10 = /** @type {(inputs: _Field_Enum_Digitell_Ja10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const de__field_enum_digitell_ja10 = /** @type {(inputs: _Field_Enum_Digitell_Ja10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {_Field_Enum_Digitell_Ja10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_digitell_ja10 = /** @type {((inputs?: _Field_Enum_Digitell_Ja10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Digitell_Ja10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_digitell_ja10(inputs)
	return de__field_enum_digitell_ja10(inputs)
});
export { _field_enum_digitell_ja10 as "_field_enum_DIGITELL_JA" }